import React, { useState, useEffect  } from 'react';
import { Link } from 'react-router-dom';
import Logo from './../assets/images/era-interiors-logo.png';

const Header = () => {
  useEffect(() => {
    // if (window.$ && window.$.fn && window.$.fn.slicknav) {
    //   window.$('#menu').slicknav({
    //     label: '',
    //     prependTo: '.responsive-menu'
    //   });
    // } else {
    //   console.warn('SlickNav or jQuery not loaded properly.');
    // }
    window.$('#menu').slicknav({
		label : '',
		prependTo : '.responsive-menu'
	});
  }, []);
  return (
    <>
      <header className="main-header">
        <div className="header-sticky">
          <nav className="container">
            <div className="navbar navbar-expand-lg">
              {/* Logo Start */}
              <Link className="navbar-brand" to="/">
                <img src={Logo} alt="Logo" />
              </Link>
              {/* Logo End */}
              {/* Main Menu Start */}
              <div className="collapse navbar-collapse main-menu">
                <div className="nav-menu-wrapper">
                  <ul className="navbar-nav mr-auto" id="menu">
                    <li className="nav-item">
                      <Link className="nav-link" to="/">
                        Home
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link className="nav-link" to="/about-us">
                        About Us
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link className="nav-link" to="/services">
                        Services
                      </Link>
                    </li>
                    {/* <li className="nav-item">
                      <Link className="nav-link" to="/projects">
                        Projects
                      </Link>
                    </li> */}
                    <li className="nav-item">
                      <Link className="nav-link" to="/gallery">
                        Gallery
                      </Link>
                    </li>
                    {/* <li className="nav-item">
                      <a className="nav-link" href="blog.html">
                        Blog
                      </a>
                    </li>
                    <li className="nav-item submenu">
                      <a className="nav-link" href="#">
                        Pages
                      </a>
                      <ul>
                        <li className="nav-item">
                          <a className="nav-link" href="service-single.html">
                            Service Details
                          </a>
                        </li>
                        <li className="nav-item">
                          <a className="nav-link" href="project-single.html">
                            Project Details
                          </a>
                        </li>
                        <li className="nav-item">
                          <a className="nav-link" href="blog-single.html">
                            Blog Details
                          </a>
                        </li>
                        <li className="nav-item">
                          <a className="nav-link" href="image-gallery.html">
                            Image Gallery
                          </a>
                        </li>
                        <li className="nav-item">
                          <a className="nav-link" href="faqs.html">
                            FAQs
                          </a>
                        </li>
                        <li className="nav-item">
                          <a className="nav-link" href="404.html">
                            404
                          </a>
                        </li>
                      </ul>
                    </li> */}
                    <li className="nav-item">
                      <Link className="nav-link" to="/contact-us">
                        Contact Us
                      </Link>
                    </li>
                  </ul>
                </div>
                {/* Header Btn Start */}
                <div className="header-btn d-inline-flex">
                  <Link to="/contact-us" className="btn-default">
                    get in touch
                  </Link>
                </div>
                {/* Header Btn End */}
              </div>
              {/* Main Menu End */}
              <div className="navbar-toggle"  />
            </div>
          </nav>
          <div className="responsive-menu" />
        </div>
      </header>
      {/* Header End */}
    </>
  )
}

export default Header
